module.exports = __webpack_public_path__ + "static/media/icon-bg-blue.e374f3fc.svg";